import { memo } from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import UserChatRoom from '@/features/Chat/chat-room'
import EmptyChatRoom from '@/features/Chat/chat-room/empty-chat-room'
import { breakpoints } from '@/styles'
import SupportChatRoom from './support-room'

const StyledEmptyRoom = styled(EmptyChatRoom)`
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding-bottom: 0;
  }
`

const ChatRoom = ({ handleBack, selectMode }) => {
  const params = useParams()
  const timelineId = params.timelineId

  if (!timelineId || selectMode) {
    return <StyledEmptyRoom handleBack={handleBack} />
  }
  return timelineId === 'support-room' ? (
    <SupportChatRoom handleBack={handleBack} />
  ) : (
    <UserChatRoom handleBack={handleBack} />
  )
}

export default memo(ChatRoom)
